//获取本地存储值
function getStorage(key) {
  let localStorage = window.localStorage || false;
  if (!localStorage) {
    return "";
  }
  return localStorage.getItem(key);
}

//本地存储值
function setStorage(key, value) {
  let localStorage = window.localStorage || false;
  if (!localStorage) {
    return;
  }
  localStorage.setItem(key, value);
}

//初始化主题属性
export function initThemeData(appData, isFold) {
  let themePath = loadThemeCss();
  appData.themePath = themePath;
  return getThemeData(themePath, isFold);
}

//更换主题存储
export function changeThemeData(appData, themePath) {
  setStorage("themePath", themePath);
  let themeData = getThemeData(themePath);
  appData.themePath = themeData.themePath;
  appData.themeColor = themeData.themeColor;
  appData.menuBgColor = themeData.menuBgColor;
  appData.menuTextColor = themeData.menuTextColor;
  appData.menuTextActiveColor = themeData.menuTextActiveColor;
}

//加载主题样式文件
function loadThemeCss() {
  let themePath = getStorage("themePath");
  // console.log("getStorage themePath === " + themePath);
  // if (null == themePath || '' === themePath) {
  themePath = "light";
  // }
  let cssFileName = "main.css";
  let includeCss = isIncludeCssLink();
  if (!includeCss) {
    let head = document.getElementsByTagName("head")[0];
    let link = document.createElement("link");
    link.href = "/static/theme/" + themePath + "/css/" + cssFileName;
    link.rel = "stylesheet";
    link.type = "text/css";
    head.appendChild(link);
  } else {
    console.log(":::" + cssFileName + " has include !!!");
  }

  return themePath;
}

//获取主题颜色值
function getThemeData(themePath, isFold) {
  if ("light" === themePath) {
    isFold = isFold === undefined ? true : isFold;
    return {
      themeColor: !isFold ? "#00a0fc" : "rgba(0,0,0,0)",
      menuBgColor: !isFold ? "#1a64ae" : "rgba(0,0,0,0)",
      themePath: themePath,
      menuTextColor: "#bce3fd",
      menuTextActiveColor: "#00a0fc"
    };
  } else if ("dark" === themePath) {
    return {
      themePath: themePath,
      themeColor: "#1b223e",
      menuBgColor: "#131934",
      menuTextColor: "#bce3fd",
      menuTextActiveColor: "#00a0fc"
    };
  }
  return "#1b223e";
}

//判断样式文件是否已引入
function isIncludeCssLink(name) {
  var es = document.getElementsByTagName('link');
  for (var i = 0; i < es.length; i++)
    if (es[i]['href'].indexOf(name) != -1) {
      return true;
    }
  return false;
}

//获取路由参数
export function getRouterParam() {
  let routerParam = getStorage("routerParam");
  if (!routerParam) {
    return null
  }
  return JSON.parse(routerParam);
}

//设置路由参数
export function changeRouterParam(appData, routerParam) {
  setStorage("routerParam", routerParam);
  appData.routerParam = routerParam;
}

//更换路段id
export function changeProjectId(appData, projectId) {
  setStorage("projectId", projectId);
  appData.projectId = projectId;
}

//获取路段id
export function getProjectId() {
  let initProjectId = getStorage("projectId");
  if (initProjectId == '') {
    return 0
  }
  return Number(initProjectId);
}



// WEBPACK FOOTER //
// ./src/utils/store.js